import { call, put } from 'redux-saga/effects';

import { DOC_UPLOAD_BANNER_ERROR_MESSAGES } from '../constants';
import { chooseFileSagaTypeDictionary } from './helpersMobile';

export function* chooseFileSaga({
  chooseDocumentCancellation,
  chooseDocumentFailure,
  chooseDocumentSuccess,
  navigationHandler,
  processDocument,
}, { payload }) {
  const { isSecondFile = false, reviewScreenName, type } = payload;
  try {
    const typeSaga = chooseFileSagaTypeDictionary[type];
    const {
      base64,
      cancelled,
      name,
      uri,
    } = yield call(typeSaga);
    /**
     * Docs say web doesn't return 'cancelled' because browsers are inconsistent. It's unclear
     * though if, when a user cancels on web, the typeSaga would return at all. Testing thus far
     * indicates it does not. But just in case it does on some browsers, we also check if uri
     * exists here.
     */
    if (!cancelled && uri) {
      yield put(processDocument({
        file: { name },
        isSecondFile,
        mobile: { base64, uri },
      }));
      yield put(chooseDocumentSuccess());
      if (reviewScreenName) {
        yield call(navigationHandler, reviewScreenName);
      }
    } else {
      yield put(chooseDocumentCancellation());
    }
  } catch {
    const bannerError = DOC_UPLOAD_BANNER_ERROR_MESSAGES.default;
    yield put(chooseDocumentFailure({ bannerError }));
    if (reviewScreenName) {
      yield call(navigationHandler, reviewScreenName);
    }
  }
}
